//
export default [
  {
    text: 'FOLIO',
    value: ({ sl_customer_receivable }) => 
      sl_customer_receivable.sl_sale_invoice ?
        sl_customer_receivable.sl_sale_invoice.number
        :
        sl_customer_receivable.sl_sale_debit_note ?
          sl_customer_receivable.sl_sale_debit_note.number
          :
          '-'
  },
  {
    text: 'sucursal',
    value: ({ sl_customer_receivable }) => 
      sl_customer_receivable.sl_customer_branch_offices ?
        sl_customer_receivable.sl_customer_branch_offices.address
        :
        '-'
  },
  {
    text: 'FECHA DE EMISIÓN',
    value: ({ sl_customer_receivable }) => 
      sl_customer_receivable.sl_sale_invoice ?
        sl_customer_receivable.sl_sale_invoice.emission_date
        :
        sl_customer_receivable.sl_sale_debit_note ?
          sl_customer_receivable.sl_sale_debit_note.emission_date
          :
          '-'
  },
  {
    text: 'FECHA DE VENCIMIENTO',
    value: ({ sl_customer_receivable }) => sl_customer_receivable.pay_date,
  },
  {
    text: 'TOTAL',
    format: 'currency',
    value: ({ sl_customer_receivable }) => 
      sl_customer_receivable.sl_sale_invoice ?
        sl_customer_receivable.sl_sale_invoice.total
        :
        sl_customer_receivable.sl_sale_debit_note ?
          sl_customer_receivable.sl_sale_debit_note.total
          :
          '-'
  },
  {
    text: 'PAGADO',
    format: 'currency',
    value: ({ sl_customer_receivable }) => sl_customer_receivable.paid_amount,
  },
  {
    text: 'MONTO',
    format: 'currency',
    value: 'amount',
  },
]